import type { Ref } from "vue";
import { ref } from "vue";

const useLoadingState = <T extends unknown[], U = unknown>(
  callback: (...args: T) => PromiseLike<U>
): [
  loadingState: Ref<boolean>,
  wrappedCallback: (...args: T) => Promise<U>,
] => {
  const isLoading = ref(false);

  return [isLoading, wrapLoadingState(isLoading, callback)];
};

const wrapLoadingState = <T extends unknown[], U = unknown>(
  loadingState: Ref<boolean>,
  callback: (...args: T) => PromiseLike<U>
): ((...args: T) => Promise<U>) => {
  const wrappedFn = async (...args: T): Promise<U> => {
    loadingState.value = true;
    try {
      return await callback(...args);
    } finally {
      loadingState.value = false;
    }
  };

  return wrappedFn;
};

export { useLoadingState as default, wrapLoadingState };
